<template>
  <div class="volume-control-container">
    <!-- 麦克风图标，用于静音/取消静音 -->
    <img @click="handleSetVol(0)" v-if="volume > 0" class="volume-control-container-img" src="../../assets/image/zbsz_kqmaikefeng_28@2x.png" alt=""/>
	<img @click="handleSetVol(100)" v-if="volume == 0" class="volume-control-container-img" src="../../assets/image/zbsz_gbmaikefeng_28@2x.png" alt=""/>

    <!-- 音量滑块 -->
    <input
      type="range"
      class="volume-slider"
      min="0"
      max="100"
      :value="volume"
      @input="handleVolumeChange"
      aria-label="Volume Level"
    />
	<span class="volume-control-container-span">{{volume}}</span>
  </div>
</template>

<script>
export default {
  name: 'VolumeControl',
  data() {
    return {
      // 在 data 函数中定义响应式数据 volume，初始值为 70
      volume: 100
    };
  },
  methods: {
    /**
     * 处理滑块拖动时的音量变化
     * @param {Event} event - 滑块的 input 事件对象
     */
    handleVolumeChange(event) {
      // 将滑块的值赋给 this.volume
      this.volume = Number(event.target.value);
	  this.$emit('setVol',this.volume)
    },
	//设置音量
	handleSetVol(data){
		this.volume = data
		this.$emit('setVol',this.volume)
	},

    /**
     * 切换静音状态
     */
    toggleMute() {
      // 如果当前是静音（volume 为 0），则恢复到最大音量（100）
      // 如果当前不是静音，则设置为静音（0）
      this.volume = this.volume === 0 ? 100 : 0;
	  this.$emit('setVol',this.volume)
    }
  }
};
</script>

<style scoped>
/* 容器样式 */
.volume-control-container {
  display: flex;
  align-items: center;
  gap: 6px; /* 图标和滑块之间的间距 */
  padding: 10px;
  border-radius: 8px;
  width: fit-content;
  width: 150px;
}

.volume-control-container-img{
	width: 22px;
	cursor: pointer;
}

/* 滑块样式 */
.volume-slider {
  -webkit-appearance: none; /* 移除 Webkit 浏览器的默认样式 */
  appearance: none;
  width: 100px; /* 滑块宽度 */
  height: 2px; /* 滑块轨道高度 */
  background: #d7e3f4; /* 轨道背景色 */
  border-radius: 3px; /* 轨道圆角 */
  outline: none;
}

/* 滑块的可拖动部分（thumb）样式 */
.volume-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 8px; /* 滑块按钮宽度 */
  height: 8px; /* 滑块按钮高度 */
  background: #ffffff; /* 滑块按钮颜色 */
  border-radius: 50%; /* 圆形按钮 */
  cursor: pointer;
  transition: all 0.15s ease;
}

/* 滑块按钮悬停效果 */
.volume-slider::-webkit-slider-thumb:hover {
  box-shadow: 0 0 0 8px rgba(24, 144, 255, 0.2);
}

/* Firefox 浏览器的滑块样式 */
.volume-slider::-moz-range-thumb {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.15s ease;
}

.volume-slider::-moz-range-thumb:hover {
  box-shadow: 0 0 0 8px rgba(24, 144, 255, 0.2);
}
.volume-control-container-span{
	font-family: MiSans, MiSans;
	font-weight: 400;
	font-size: 14px;
	color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// yinliang.vue?328aa358